export const sortSourcesAlphabetically = (sources, { getSourceLabel }) => {
    return sources.sort((a, b) => {
        const labelA = getSourceLabel(a);
        const labelB = getSourceLabel(b);
        // Handle undefined labels by treating them as empty strings
        return (labelA ?? '').localeCompare(labelB ?? '');
    });
};
//# sourceMappingURL=sortSourcesAlphabetically.js.map